module.exports = __webpack_public_path__ + "img/Lexikan_1000px.0eb68197.png";